import { render, staticRenderFns } from "./ProductOrders.vue?vue&type=template&id=e6a5413a&scoped=true&"
import script from "./ProductOrders.vue?vue&type=script&lang=js&"
export * from "./ProductOrders.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrders.vue?vue&type=style&index=0&id=e6a5413a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a5413a",
  null
  
)

export default component.exports